import Vue from 'vue'
import axios from '@axios'
import axiosVanilla from 'axios'

export const state = {
  cars: [],
  car: {},
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 0,
  isLoading: false,
}

export const getters = {
  allCars: (state) => state.cars,
  currentCar: (state) => state.car,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
  isLoading: (state) => state.isLoading,
}

export const mutations = {
  GET_CAR: (state, resp) => {
    if (!resp) return null
    state.car = { ...resp }
  },
  GET_CARS: (state, resp) => {
    if (!resp) return null
    state.cars = resp.cars
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecords = resp.totalRecords
  },
  CREATE_CAR: (state, resp) => {
    if (!resp) return null
    state.cars.unshift(resp)
  },
  UPDATE_CAR: (state, resp) => {
    if (!resp) return null
    for (let i = 0; i < state.cars.length; i++) {
      if (state.cars[i].id === resp.id) {
        Vue.set(state.cars, i, { ...resp })
        break
      }
    }
  },
  UPDATE_CARS: (state, resp) => {
    if (!resp) return null
    resp.forEach((respCar) => {
      const index = state.cars.findIndex((car) => car.id === respCar.id)
      if (index !== -1) {
        Vue.set(state.cars, index, { ...respCar })
      }
    })
  },
  DELETE_CAR: (state, deletedCar) => {
    if (!deletedCar) return null
    state.cars = state.cars.filter((car) => car.id !== deletedCar.id)
  },
  UPLOAD_MEDIEAS: (state, resp) => {
    if (!resp) return null
    state.cars.forEach((car, carIndex) => {
      if (car.id === resp.carId) {
        let allMedia = [...resp.medias, ...car[resp.mediaType]]
        state.cars[carIndex][resp.mediaType] = allMedia
      }
    })
  },
  SET_CAR_MEDIA(state, { carId, mediaType, medias }) {
    const carIndex = state.cars.findIndex((car) => car.id === carId)
    if (carIndex !== -1) {
      Vue.set(state.cars[carIndex], mediaType, medias)
    }
  },
  SET_CAR_SELF_NOTE(state, { carId, selfNote }) {
    const carIndex = state.cars.findIndex((car) => car.id === carId)
    if (carIndex !== -1) {
      state.cars[carIndex].selfNote = selfNote
    }
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading
  },
}

export const actions = {
  async getCars({ commit }, params = {}) {
    commit('SET_LOADING', true)
    const requestParams = {
      ...params,
      ...(!params.sortBy && { sortBy: 'created_date', orderBy: 'desc' }),
    }
    await axios
      .get(`/api/cars`, {
        params: requestParams,
      })
      .then((resp) => {
        if (resp.status === 200) {
          let data = Object.assign({}, resp.data)
          commit('GET_CARS', data)
        }
        commit('SET_LOADING', false)
      })
      .catch((err) => {
        let data = err.response.status === 404 ? { cars: [] } : null
        commit('GET_CARS', data)
        commit('SET_LOADING', false)
      })
  },
  async getCarByVIN({ commit }, VIN = '') {
    return axios.get(`/api/cars`, {
      params: { vin: VIN },
    })
  },
  async getCarByKey({ commit }, params) {
    return axios.get(`/api/cars`, {
      params: params,
    })
  },
  async getMediaCar({ commit }, id) {
    return axios.get(`/api/car/invoice/${id}`)
  },
  async getCarInforByVIN({ commit }, VIN = '') {
    return axiosVanilla.get(
      `https://vpic.nhtsa.dot.gov/api/vehicles/decodevinvaluesextended/${VIN}?format=json`
    )
  },
  async createCar({ commit }, form) {
    return axios
      .post('/api/cars', form)
      .then((resp) => {
        if (resp.status === 201) {
          commit('CREATE_CAR', Object.assign({}, resp.data))
        }
        return resp
      })
      .catch((err) => {
        commit('CREATE_CAR', null)
        return err
      })
  },
  async updateCar({ commit, dispatch, state }, form) {
    return axios
      .put('/api/cars', form)
      .then((resp) => {
        if (resp.status === 200) {
          commit('UPDATE_CAR', Object.assign({}, resp.data))
          let notification = {
            id: Date.now(),
            message: 'Vihecle information is uploaded.',
            title: 'Vihecle',
            type: 'success',
          }
          dispatch('notification/addNotification', notification, {
            root: true,
          })
        }
        return resp
      })
      .catch((err) => {
        commit('UPDATE_CAR', null)
        let notification = {
          id: Date.now(),
          message: 'Failed to upload Vihecle information.',
          title: 'Vihecle',
          type: 'error',
        }
        dispatch('notification/addNotification', notification, {
          root: true,
        })
        return err
      })
  },
  async updateCars({ commit, dispatch, state }, form) {
    return axios
      .put('/api/cars/multiple', form)
      .then((resp) => {
        if (resp.status === 200) {
          commit('UPDATE_CARS', resp.data.cars)
          let notification = {
            id: Date.now(),
            message: 'Vihecle informations are uploaded.',
            title: 'Vihecle',
            type: 'success',
          }
          dispatch('notification/addNotification', notification, {
            root: true,
          })
        }
        return resp
      })
      .catch((err) => {
        commit('UPDATE_CARS', null)
        // Extract error message from response
        const errorMessage =
          (err.response &&
            err.response.data &&
            err.response.data.description) ||
          (err.response && err.response.data && err.response.data.message) ||
          'Failed to upload Vihecle information.'
        let notification = {
          id: Date.now(),
          message: errorMessage,
          title: 'Vihecle',
          type: 'error',
        }
        dispatch('notification/addNotification', notification, {
          root: true,
        })
        return err
      })
  },
  async updateCarSelfNote({ commit }, form) {
    return axios
      .put('/api/cars/self-note', form)
      .then((resp) => {
        if (resp.status === 200) {
          commit('SET_CAR_SELF_NOTE', {
            carId: form.carId,
            selfNote: form.selfNote,
          })
        }
        return resp
      })
      .catch((err) => {
        return err
      })
  },
  async deleteCar({ commit }, form) {
    return axios
      .delete('/api/cars', { data: form })
      .then((resp) => {
        if (resp.status === 204) {
          commit('DELETE_CAR', Object.assign({}, form))
          return true
        }
      })
      .catch(() => {
        commit('DELETE_CAR', null)
        return false
      })
  },
  async uploadFiles({ commit, dispatch }, data) {
    let form = new FormData()
    let notification = {
      id: Date.now(),
      message: 'Files are uploading',
      type: 'info',
    }
    dispatch('notification/addNotification', notification, {
      root: true,
    })
    for (let field in data) {
      if (field === 'files') {
        for (let file of data[field]) {
          form.append('files', file, file.name)
        }
        continue
      }
      form.append(field, data[field])
    }
    await axios
      .post(`/api/medias`, form)
      .then((resp) => {
        if (resp.status === 201) {
          let submitData = resp.data
          submitData.carId = data.carId
          submitData.mediaType = data.mediaType
          commit('UPLOAD_MEDIEAS', submitData)
          notification = {
            id: Date.now(),
            message: 'Files are uploaded.',
            type: 'info',
          }
          dispatch('getCars', {
            page: state.currentPage,
            perPage: 15,
          })
          dispatch('notification/addNotification', notification, {
            root: true,
          })
        }
      })
      .catch(() => {
        commit('UPLOAD_MEDIEAS', null)
      })
  },
  async deleteFile({ commit }, file) {
    await axios
      .delete(`/api/medias`, { data: file })
      .then((resp) => {
        if (resp.status === 204) {
          commit('DELETE_FILE', file)
        }
      })
      .catch(() => {
        commit('DELETE_FILE', null)
      })
  },

  async exportCar({ commit }, params) {
    return axios.post('/api/cars/export', null, {
      params: params,
    })
  },
  async downloadCar({ commit }, payload) {
    return axios.post('/api/cars/download', payload)
  },
  async getShareVehicle({ commit }, VIN = '') {
    return axios.get(`/api/vehicle/share/${VIN}`, {})
  },
  async generateDockReceipt({ commit, dispatch }, payload) {
    try {
      const response = await axios.post('/api/cars/dock-receipt', payload, {
        responseType: 'blob',
      })

      if (response.status === 200) {
        // Create a download link for the HTML file
        const blob = new Blob([response.data], { type: 'text/html' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url

        // Extract filename from content-disposition header if available
        const contentDisposition = response.headers['content-disposition']
        let filename = 'dock_receipt.html'
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?(.+)"?/)
          if (filenameMatch) {
            filename = filenameMatch[1]
          }
        }

        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        const notification = {
          id: Date.now(),
          message: 'Dock Receipt generated successfully.',
          title: 'Dock Receipt',
          type: 'success',
        }
        dispatch('notification/addNotification', notification, { root: true })

        return response
      }
    } catch (err) {
      const errorMessage =
        err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : 'Failed to generate Dock Receipt.'

      const notification = {
        id: Date.now(),
        message: errorMessage,
        title: 'Dock Receipt',
        type: 'error',
      }
      dispatch('notification/addNotification', notification, { root: true })
      throw err
    }
  },
  async generateCommercialInvoice({ commit, dispatch }, payload) {
    try {
      // Show loading notification
      const loadingNotification = {
        id: Date.now(),
        message: 'Generating Commercial Invoice...',
        title: 'Commercial Invoice',
        type: 'info',
      }
      dispatch('notification/addNotification', loadingNotification, {
        root: true,
      })

      const response = await axios.post(
        '/api/generated/commercial-invoice',
        payload
      )

      if (response.status === 201) {
        const media = response.data

        const fileUrl = media.src || media.file || null

        if (fileUrl) {
          try {
            const fileResponse = await axios.get(fileUrl, {
              responseType: 'blob',
            })

            if (fileResponse.status === 200) {
              const blob = new Blob([fileResponse.data], {
                type: 'application/pdf',
              })
              const url = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.style.display = 'none'

              // Extract filename from URL or use default
              const filename =
                media.name ||
                (fileUrl.includes('/')
                  ? fileUrl.substring(fileUrl.lastIndexOf('/') + 1)
                  : 'commercial_invoice.pdf') ||
                'commercial_invoice.pdf'
              link.setAttribute('download', filename)
              document.body.appendChild(link)
              link.click()

              // Clean up after a short delay
              setTimeout(() => {
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
              }, 100)
            }
          } catch (fileErr) {
            console.error('Error downloading Commercial Invoice file:', fileErr)
            // Fallback: open in new tab if download fails
            const fallbackUrl = media.src || media.file
            if (fallbackUrl) {
              window.open(fallbackUrl, '_blank')
            }
          }
        } else {
          console.warn('No file URL found in media response:', media)
        }

        const notification = {
          id: Date.now(),
          message: 'Commercial Invoice generated successfully.',
          title: 'Commercial Invoice',
          type: 'success',
        }
        dispatch('notification/addNotification', notification, { root: true })

        return response
      }
    } catch (err) {
      const errorMessage =
        err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : 'Failed to generate Commercial Invoice.'

      const notification = {
        id: Date.now(),
        message: errorMessage,
        title: 'Commercial Invoice',
        type: 'error',
      }
      dispatch('notification/addNotification', notification, { root: true })
      throw err
    }
  },
  async generateCoverLetter({ commit, dispatch }, payload) {
    try {
      const loadingNotification = {
        id: Date.now(),
        message: 'Generating Cover Letter...',
        title: 'Cover Letter',
        type: 'info',
      }
      dispatch('notification/addNotification', loadingNotification, {
        root: true,
      })

      const response = await axios.post('/api/generated/cover-letter', payload)

      if (response.status === 201) {
        const media = response.data

        const fileUrl = media.src || media.file || null

        if (fileUrl) {
          try {
            const fileResponse = await axios.get(fileUrl, {
              responseType: 'blob',
            })

            if (fileResponse.status === 200) {
              const blob = new Blob([fileResponse.data], {
                type: 'application/pdf',
              })
              const url = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.style.display = 'none'

              const filename =
                media.name ||
                (fileUrl.includes('/')
                  ? fileUrl.substring(fileUrl.lastIndexOf('/') + 1)
                  : 'cover_letter.pdf') ||
                'cover_letter.pdf'
              link.setAttribute('download', filename)
              document.body.appendChild(link)
              link.click()

              setTimeout(() => {
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
              }, 100)
            }
          } catch (fileErr) {
            console.error('Error downloading Cover Letter file:', fileErr)
            const fallbackUrl = media.src || media.file
            if (fallbackUrl) {
              window.open(fallbackUrl, '_blank')
            }
          }
        } else {
          console.warn('No file URL found in media response:', media)
        }

        const notification = {
          id: Date.now(),
          message: 'Cover Letter generated successfully.',
          title: 'Cover Letter',
          type: 'success',
        }
        dispatch('notification/addNotification', notification, { root: true })

        return response
      }
    } catch (err) {
      const errorMessage =
        err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : 'Failed to generate Cover Letter.'

      const notification = {
        id: Date.now(),
        message: errorMessage,
        title: 'Cover Letter',
        type: 'error',
      }
      dispatch('notification/addNotification', notification, { root: true })
      throw err
    }
  },
  async generatePackingList({ commit, dispatch }, payload) {
    try {
      const loadingNotification = {
        id: Date.now(),
        message: 'Generating Packing List...',
        title: 'Packing List',
        type: 'info',
      }
      dispatch('notification/addNotification', loadingNotification, {
        root: true,
      })

      const response = await axios.post('/api/generated/packing-list', payload)

      if (response.status === 201) {
        const media = response.data

        const fileUrl = media.src || media.file || null

        if (fileUrl) {
          try {
            const fileResponse = await axios.get(fileUrl, {
              responseType: 'blob',
            })

            if (fileResponse.status === 200) {
              const blob = new Blob([fileResponse.data], {
                type: 'application/pdf',
              })
              const url = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.style.display = 'none'

              const filename =
                media.name ||
                (fileUrl.includes('/')
                  ? fileUrl.substring(fileUrl.lastIndexOf('/') + 1)
                  : 'packing_list.pdf') ||
                'packing_list.pdf'
              link.setAttribute('download', filename)
              document.body.appendChild(link)
              link.click()

              setTimeout(() => {
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
              }, 100)
            }
          } catch (fileErr) {
            console.error('Error downloading Packing List file:', fileErr)
            const fallbackUrl = media.src || media.file
            if (fallbackUrl) {
              window.open(fallbackUrl, '_blank')
            }
          }
        } else {
          console.warn('No file URL found in media response:', media)
        }

        const notification = {
          id: Date.now(),
          message: 'Packing List generated successfully.',
          title: 'Packing List',
          type: 'success',
        }
        dispatch('notification/addNotification', notification, { root: true })

        return response
      }
    } catch (err) {
      const errorMessage =
        err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : 'Failed to generate Packing List.'

      const notification = {
        id: Date.now(),
        message: errorMessage,
        title: 'Packing List',
        type: 'error',
      }
      dispatch('notification/addNotification', notification, { root: true })
      throw err
    }
  },
  async fetchDockReceiptPdf({ commit }, payload) {
    const response = await axios.post('/api/cars/dock-receipt', payload, {
      responseType: 'arraybuffer',
    })
    return response.data
  },
  async fetchCoverLetterPdf({ commit }, payload) {
    const response = await axios.post('/api/generated/cover-letter', payload)
    const fileUrl = response.data.src || response.data.file
    if (!fileUrl) throw new Error('No file URL in cover letter response')
    const fileResponse = await axios.get(fileUrl, {
      responseType: 'arraybuffer',
    })
    return fileResponse.data
  },
}
